import { dateTimeFieldToDate } from "./externalFunctions";

// searchCategories = [String categori yang ingin difilter]
// filterText = filter input
// ex. itemList.filter(filterSearch(searchCategories, filterText))
export const filterSearch = (searchCategories, filterText) => (item) =>
  searchCategories.filter(
    (category) =>
      item[category] &&
      String(item[category]).toLowerCase().includes(filterText.toLowerCase())
  ).length > 0;

export const filterSearchNumType = (searchCategories, filterText) => (item) =>
  filterText === ""
    ? item
    : searchCategories.filter(
        (category) =>
          item[category] && Number(item[category]) === Number(filterText)
      ).length > 0;

export const filterStatus = (statusStr, filterStatus) => (item) =>
  Number(filterStatus) === 0
    ? item
    : Number(item[statusStr]) &&
      Number(item[statusStr]) === Number(filterStatus);

export const filterSumberDana = (sumberDanaStr, filterSumberDana) => (item) => {
  if (
    Number(filterSumberDana) === 51 ||
    Number(filterSumberDana) === 61 ||
    Number(filterSumberDana) === 81
  ) {
    return filterSearchNumType([sumberDanaStr], filterSumberDana)(item);
  } else if (Number(filterSumberDana) === 0) {
    return item;
  }
};

// date filter
export const filterEqualToDate = (dateStr, filterDate) =>
  filterBetweenDate(dateStr, dateStr, filterDate);

export const filterBetweenDate =
  (beforeDateStr, afterDateStr, filterDate) => (item) => {
    return filterDate === ""
      ? item
      : filterBeforeDate(beforeDateStr, filterDate)(item) &&
          filterAfterDate(afterDateStr, filterDate)(item);
  };

export const filterBeforeDate = (beforeDateStr, filterDate) => (item) => {
  return filterDate === ""
    ? item
    : item[beforeDateStr] &&
        dateTimeFieldToDate(item[beforeDateStr]) <= filterDate;
};

export const filterAfterDate = (afterDateStr, filterDate) => (item) => {
  return filterDate === ""
    ? item
    : item[afterDateStr] &&
        dateTimeFieldToDate(item[afterDateStr]) >= filterDate;
};
